// extracted by mini-css-extract-plugin
module.exports = {"outerWrapper":"patient_view-module__outerWrapper___qjhiC"};